// GENERATED by tools/profile-gen/generate.py from tools/profile-gen/badges.manifest.json.
// Do not hand-edit — change the manifest and regenerate.

/** The countable platform metric a badge thresholds on — computed by the
 *  badge engine (src/badges/evaluate.ts). */
export type BadgeMetric =
  | 'games_finished'
  | 'mp_games_finished'
  | 'assets_created'
  | 'iterations'
  | 'forks_created'
  | 'likes_given'
  | 'comments_posted'
  | 'games_created'
  | 'play_days_week'
  | 'profile_claimed'
  | 'editors_picks'
  | 'leaderboards_topped'
  | 'large_leaderboards_topped'
  | 'chat_peers';

/** One achievement badge's machine definition (art + display copy live in
 *  the portal's generated badgeManifest.ts — same manifest, same regen). */
export interface BadgeDef {
  id: string;
  name: string;
  criteria: string;
  tier: 1 | 2;
  metric: BadgeMetric;
  /** Award when the metric value reaches AT LEAST this. */
  threshold: number;
}

export const BADGE_DEFS: readonly BadgeDef[] = [
  { id: 'player', name: 'Player', criteria: 'Finish 3 different games', tier: 1, metric: 'games_finished', threshold: 3 },
  { id: 'gamer', name: 'Gamer', criteria: 'Finish 10 different games', tier: 2, metric: 'games_finished', threshold: 10 },
  { id: 'designer', name: 'Designer', criteria: 'Create more than 5 assets', tier: 1, metric: 'assets_created', threshold: 6 },
  { id: 'artist', name: 'Artist', criteria: 'Create more than 20 assets', tier: 2, metric: 'assets_created', threshold: 21 },
  { id: 'tinkerer', name: 'Tinkerer', criteria: 'Iterate a game more than 5 times', tier: 1, metric: 'iterations', threshold: 6 },
  { id: 'engineer', name: 'Engineer', criteria: 'Iterate a game more than 10 times', tier: 2, metric: 'iterations', threshold: 11 },
  { id: 'innovator', name: 'Innovator', criteria: 'Fork more than 3 different games', tier: 1, metric: 'forks_created', threshold: 4 },
  { id: 'visionary', name: 'Visionary', criteria: 'Fork more than 10 different games', tier: 2, metric: 'forks_created', threshold: 11 },
  { id: 'fan-boy', name: 'Fan Boy', criteria: 'Like more than 5 games', tier: 1, metric: 'likes_given', threshold: 6 },
  { id: 'regular', name: 'Regular', criteria: 'Play on 3 different days in one week', tier: 1, metric: 'play_days_week', threshold: 3 },
  { id: 'patron', name: 'Patron', criteria: 'Play every day for a whole week', tier: 2, metric: 'play_days_week', threshold: 7 },
  { id: 'chatterbox', name: 'Chatterbox', criteria: 'Post your 5th comment', tier: 1, metric: 'comments_posted', threshold: 5 },
  { id: 'opinionated', name: 'Opinionated', criteria: 'Post your 10th comment', tier: 2, metric: 'comments_posted', threshold: 10 },
  { id: 'squatter', name: 'Squatter', criteria: 'Set your profile name or picture', tier: 1, metric: 'profile_claimed', threshold: 1 },
  { id: 'playmate', name: 'Playmate', criteria: 'Finish 3 multiplayer games', tier: 1, metric: 'mp_games_finished', threshold: 3 },
  { id: 'multiplayer', name: 'Multiplayer', criteria: 'Finish 10 multiplayer games', tier: 2, metric: 'mp_games_finished', threshold: 10 },
  { id: 'maker', name: 'Maker', criteria: 'Create more than 5 games', tier: 1, metric: 'games_created', threshold: 6 },
  { id: 'renaissance-person', name: 'Renaissance Person', criteria: 'Create more than 10 games', tier: 2, metric: 'games_created', threshold: 11 },
  { id: 'editors-pick', name: 'Editors\' Pick', criteria: 'Have a game selected as an Editors\' Pick', tier: 2, metric: 'editors_picks', threshold: 1 },
  { id: 'top-of-the-flock', name: 'Top of the Flock', criteria: 'Reach #1 on a leaderboard with at least 2 players', tier: 1, metric: 'leaderboards_topped', threshold: 1 },
  { id: 'triple-crown', name: 'Triple Crown', criteria: 'Reach #1 on 3 different leaderboards with at least 2 players', tier: 2, metric: 'leaderboards_topped', threshold: 3 },
  { id: 'peoples-champion', name: 'People\'s Champion', criteria: 'Reach #1 on a leaderboard with at least 11 players', tier: 2, metric: 'large_leaderboards_topped', threshold: 1 },
  { id: 'say-hello', name: 'Say Hello', criteria: 'Chat with 1 other user in the Clubhouse', tier: 1, metric: 'chat_peers', threshold: 1 },
  { id: 'group-chat', name: 'Group Chat', criteria: 'Chat with 3 other users in the Clubhouse', tier: 1, metric: 'chat_peers', threshold: 3 },
  { id: 'full-house', name: 'Full House', criteria: 'Chat with 10 other users in the Clubhouse', tier: 2, metric: 'chat_peers', threshold: 10 },
];
